import { render, staticRenderFns } from "./AcceptCount.vue?vue&type=template&id=180fe2a0&scoped=true"
import script from "./AcceptCount.vue?vue&type=script&lang=js"
export * from "./AcceptCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180fe2a0",
  null
  
)

export default component.exports